import colors from './colors.js';
export default {
  name: 'light',
  colors: {
    primary: colors.cornflower500,
    primaryShade: colors.cornflower600,
    primaryLight: colors.cornflower400,
    primaryDark: colors.cornflower900,
    foreground: {
      primary: colors.black,
      secondary: colors.eucalyptus700,
      tertiary: colors.eucalyptus500,
      destructive: colors.orchid500,
      destructiveDark: colors.orchid800,
      warning: colors.dandelion500,
      warningDark: colors.dandelion800,
      success: colors.dahlia500,
      successDark: colors.dahlia800,
      info: colors.cornflower800,
      splash: colors.eucalyptus700,
      disabled: colors.eucalyptus400
    },
    background: {
      primary: colors.white,
      secondary: colors.wildrose200,
      tertiary: colors.eucalyptus100,
      quaternary: colors.cornflower200,
      splash: colors.eucalyptus100,
      success: colors.dahlia100,
      warning: colors.dandelion100,
      destructive: colors.orchid100,
      info: colors.cornflower100,
      disabled: colors.eucalyptus200
    },
    swatch: {
      gray: colors.eucalyptus400,
      silver: colors.eucalyptus200,
      white: colors.white,
      black: colors.black,
      red: colors.rose,
      blue: colors.cornflower500,
      green: colors.amaranth,
      yellow: colors.dandelion500,
      orange: colors.tulip,
      purple: colors.lavender,
      brown: colors.tobacco
    },
    border: colors.eucalyptus200,
    separator: colors.eucalyptus200
  },
  tokens: {
    focusColor: colors.cornflower500 + '50',
    inputControlDisabledBackground: colors.eucalyptus200,
    inputDisabledBackground: colors.eucalyptus100,
    inputDisabledBorder: colors.eucalyptus300,
    // actionButton
    buttonPrimaryColor: colors.cornflower500,
    buttonPrimaryForeground: colors.white,
    buttonPrimaryHover: colors.cornflower600,
    buttonPrimaryAlternateColor: colors.eucalyptus900,
    buttonPrimaryAlternateForeground: colors.white,
    buttonPrimaryAlternateHover: colors.black,
    buttonControlForeground: colors.cornflower900,
    buttonControlHover: colors.eucalyptus100,
    buttonControlColor: colors.white,
    buttonControlBorder: colors.eucalyptus400,
    buttonLinkColor: colors.cornflower500,
    buttonLinkForeground: colors.cornflower900,
    buttonLinkHover: colors.cornflower900,
    buttonFunctionForeground: colors.cornflower500,
    buttonFunctionForegroundAlternate: colors.black,
    buttonFunctionHover: colors.cornflower100,
    buttonFunctionHoverAlternate: colors.eucalyptus100,
    buttonFunctionHoverForeground: colors.cornflower600,
    buttonPrimaryLoading: colors.white,
    buttonPrimaryAlternateLoading: colors.white,
    buttonControlLoading: colors.cornflower900,
    // actionLink
    linkPrimaryForeground: colors.cornflower600,
    linkPrimaryHover: colors.cornflower500,
    linkPrimaryAlternateForeground: colors.black,
    linkControlForeground: colors.eucalyptus500,
    linkControlHover: colors.eucalyptus600,
    // floatingActionButton
    actionButtonDisabledForeground: colors.eucalyptus400,
    actionButtonPrimaryActiveBackground: colors.cornflower600,
    actionButtonPrimaryActiveBorder: colors.cornflower600,
    actionButtonPrimaryBackground: colors.cornflower500,
    actionButtonPrimaryBorder: colors.cornflower500,
    actionButtonPrimaryDisabledBackground: colors.eucalyptus200,
    actionButtonPrimaryDisabledBorder: colors.eucalyptus200,
    actionButtonPrimaryForeground: colors.white,
    actionButtonPrimaryHoverBackground: colors.cornflower600,
    actionButtonPrimaryHoverBorder: colors.cornflower600,
    actionButtonPrimaryAlternateActiveBackground: colors.black,
    actionButtonPrimaryAlternateActiveBorder: colors.black,
    actionButtonPrimaryAlternateBackground: colors.eucalyptus900,
    actionButtonPrimaryAlternateBorder: colors.eucalyptus900,
    actionButtonPrimaryAlternateDisabledBackground: colors.eucalyptus300,
    actionButtonPrimaryAlternateDisabledBorder: colors.eucalyptus300,
    actionButtonPrimaryAlternateForeground: colors.white,
    actionButtonPrimaryAlternateHoverBackground: colors.black,
    actionButtonPrimaryAlternateHoverBorder: colors.black,
    actionButtonControlActiveBackground: colors.eucalyptus100,
    actionButtonControlActiveBorder: colors.eucalyptus400,
    actionButtonControlBackground: colors.white,
    actionButtonControlBorder: colors.eucalyptus400,
    actionButtonControlDisabledBackground: colors.white,
    actionButtonControlDisabledBorder: colors.eucalyptus200,
    actionButtonControlForeground: colors.black,
    actionButtonControlHoverBackground: colors.eucalyptus100,
    actionButtonControlHoverBorder: colors.eucalyptus400,
    actionButtonFunctionActiveBackground: colors.eucalyptus100,
    actionButtonFunctionActiveBorder: colors.eucalyptus100,
    actionButtonFunctionBackground: 'transparent',
    actionButtonFunctionBorder: 'transparent',
    actionButtonFunctionDisabledBackground: 'transparent',
    actionButtonFunctionDisabledBorder: 'transparent',
    actionButtonFunctionForeground: colors.black,
    actionButtonFunctionHoverBackground: colors.eucalyptus100,
    actionButtonFunctionHoverBorder: colors.eucalyptus100
  }
};